"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationsForm = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var styles = __importStar(require("./AutomationsForm.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var ActionForm_1 = require("./ActionForm");
var AutomationUtils_1 = require("Library/AutomationLibrary/AutomationUtils");
var MAX_NUM_ACTIONS = 3;
var ASSETS_DIR = "/Assets/";
var OTHER_TRIGGER_GROUP = "Others";
var images = {
    slackMessageImage: "".concat(ASSETS_DIR, "Images/automations/message.svg"),
};
var AutomationsForm = function (_a) {
    var e_1, _b;
    var _c;
    var triggersAndActions = _a.triggersAndActions, integrationTarget = _a.integrationTarget, currentAutomation = _a.currentAutomation, onAutomationChange = _a.onAutomationChange, disabled = _a.disabled;
    var Icon = (integrationTarget.integrationName &&
        icons[integrationTarget.enabled
            ? (0, lodash_1.capitalize)(integrationTarget.integrationName)
            : "".concat((0, lodash_1.capitalize)(integrationTarget.integrationName), "Grayscale")]) ||
        icons.Tokens;
    var selectTrigger = function (trigger) {
        onAutomationChange(__assign(__assign({}, currentAutomation), { triggerId: trigger.id, actions: [] }));
    };
    var selectAction = function (action, index) {
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: __spreadArray(__spreadArray(__spreadArray([], __read(currentAutomation.actions.slice(0, index)), false), [
                {
                    actionId: action.id,
                    config: createActionConfig(action),
                }
            ], false), __read(currentAutomation.actions.slice(index + 1)), false) }));
    };
    var addNewAction = function (action) {
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: __spreadArray(__spreadArray([], __read(currentAutomation.actions), false), [
                {
                    actionId: action.id,
                    config: createActionConfig(action),
                },
            ], false) }));
    };
    var deleteAction = function (indexToDelete) {
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: currentAutomation.actions.filter(function (action, index) { return index !== indexToDelete; }) }));
    };
    var updateAction = function (index, updatedAction) {
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: __spreadArray(__spreadArray(__spreadArray([], __read(currentAutomation.actions.slice(0, index)), false), [
                {
                    actionId: updatedAction.id,
                    config: updatedAction.config,
                }
            ], false), __read(currentAutomation.actions.slice(index + 1)), false) }));
    };
    var dropdownRef = react_1.default.createRef();
    var selectedActions = currentAutomation.actions.length === 0
        ? [
            {
                label: "",
                id: "",
                integration: "",
                supportedTriggers: [],
                config: {},
            },
        ]
        : currentAutomation.actions.map(function (action) {
            var actionDefinition = triggersAndActions.actions.find(function (_a) {
                var id = _a.id;
                return id == action.actionId;
            });
            if (!actionDefinition) {
                throw "Action ".concat(action.actionId, " not found ");
            }
            return __assign(__assign({}, actionDefinition), { config: action.config });
        });
    var availableActions = getAvailableActions(triggersAndActions.actions, {
        selectedActions: selectedActions,
        selectedTrigger: currentAutomation.triggerId,
    });
    var canAddMoreActions = selectedActions.length < MAX_NUM_ACTIONS && availableActions.length !== 0;
    var getAddButtonTooltip = function () {
        if (canAddMoreActions) {
            return { content: "Add action", size: kaleidoscope_1.TooltipSize.Small };
        }
        else {
            return selectedActions.length === MAX_NUM_ACTIONS
                ? { content: "A maximum of three actions is allowed per automation", size: kaleidoscope_1.TooltipSize.Large }
                : { content: "No additional actions available", size: kaleidoscope_1.TooltipSize.Large };
        }
    };
    var triggerGroups = new Map();
    try {
        for (var _d = __values(triggersAndActions.triggers), _e = _d.next(); !_e.done; _e = _d.next()) {
            var trigger = _e.value;
            var groupName = trigger.group || OTHER_TRIGGER_GROUP;
            var currentTriggerList = triggerGroups.get(groupName) || [];
            triggerGroups.set(groupName, __spreadArray(__spreadArray([], __read(currentTriggerList), false), [trigger], false));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    triggerGroups = new Map(__spreadArray([], __read(triggerGroups.entries()), false).sort().sort(function (a, b) {
        if (b[0] === OTHER_TRIGGER_GROUP) {
            return -1;
        }
        else if (a[0] === OTHER_TRIGGER_GROUP) {
            return 1;
        }
        return 0;
    }));
    var connectAppTooltipContent = function () { return (react_1.default.createElement(kaleidoscope_1.Stack, null,
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Connect to explore"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Connect the app first to explore the content of this automation."))); };
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement("div", { className: styles.blocks },
            react_1.default.createElement("div", { className: styles.block },
                react_1.default.createElement("div", { className: styles.trigger },
                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.label }, "When"),
                    react_1.default.createElement(kaleidoscope_1.Tooltip, { show: disabled ? undefined : false, size: kaleidoscope_1.TooltipSize.Large, content: connectAppTooltipContent(), wrapTarget: true },
                        react_1.default.createElement(kaleidoscope_1.Select, { label: "Select a trigger", placeholder: "Select a trigger", value: currentAutomation.triggerId, labelHidden: true, autoStack: true, onChange: lodash_1.noop, icon: integrationTarget.enabled ? react_1.default.createElement(icons_1.Qwilr, null) : react_1.default.createElement(icons_1.QwilrGrayscale, null), disabled: disabled }, Array.from(triggerGroups.entries()).map(function (_a) {
                            var _b = __read(_a, 2), group = _b[0], triggerList = _b[1];
                            return (react_1.default.createElement("div", null,
                                react_1.default.createElement("div", { className: styles.triggerGroup }, group),
                                react_1.default.createElement("div", { className: styles.triggerOption }, triggerList.map(function (trigger) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: trigger.id, value: trigger.id, onClick: function () { return selectTrigger(trigger); } }, trigger.label)); }))));
                        })))),
                react_1.default.createElement("div", { className: styles.actions },
                    selectedActions.map(function (action, index) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.action, action.label && styles.leftLine), key: index },
                        index == 0 ? (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.label }, "Do this")) : (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.label }, "And")),
                        react_1.default.createElement("div", { className: styles.actionBlock },
                            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.formWrapper, gap: "s" },
                                react_1.default.createElement(kaleidoscope_1.Tooltip, { show: disabled || !currentAutomation.triggerId ? undefined : false, size: kaleidoscope_1.TooltipSize.Large, content: disabled ? connectAppTooltipContent() : react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Select the trigger first"), wrapTarget: true },
                                    react_1.default.createElement(kaleidoscope_1.Select, { label: "Select an action", placeholder: "Select an action", value: action.id, labelHidden: true, autoStack: true, onChange: lodash_1.noop, icon: react_1.default.createElement(Icon, null), disabled: disabled || !currentAutomation.triggerId }, getAvailableActions(triggersAndActions.actions, {
                                        selectedActions: selectedActions,
                                        selectedTrigger: currentAutomation.triggerId,
                                        includeAction: action,
                                    }).map(function (action) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: action.id, value: action.id, onClick: function () { return selectAction(action, index); } }, action.label)); }))),
                                action.description && (react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s" }, action.description)),
                                action.form && (react_1.default.createElement(ActionForm_1.ActionForm, { action: action, onChange: function (action) { return updateAction(index, action); }, integration: integrationTarget })),
                                action.preview && renderPreviewLink(action.preview)),
                            index > 0 && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.deleteActionButton, icon: react_1.default.createElement(icons_1.Delete, null), onClick: function () { return deleteAction(index); } }))))); }),
                    ((_c = selectedActions[selectedActions.length - 1]) === null || _c === void 0 ? void 0 : _c.label) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Select, { label: "", value: "", ref: dropdownRef, labelHidden: true, autoStack: true, onChange: lodash_1.noop, className: styles.addActionDropdown, disabled: disabled }, getAvailableActions(triggersAndActions.actions, {
                            selectedActions: selectedActions,
                            selectedTrigger: currentAutomation.triggerId,
                        }).map(function (action) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: action.id, value: action.id, onClick: function () {
                                addNewAction(action);
                            } }, action.label)); })),
                        react_1.default.createElement("div", { className: styles.addActionButtonWrapper },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, className: styles.addActionButton, icon: react_1.default.createElement(icons_1.Add, null), isRound: true, onClick: function () {
                                    if (dropdownRef.current) {
                                        dropdownRef.current.click();
                                    }
                                }, disabled: disabled ? true : !canAddMoreActions, tooltip: getAddButtonTooltip() })))))))));
};
exports.AutomationsForm = AutomationsForm;
var renderPreviewLink = function (_a) {
    var image = _a.image, label = _a.label, icon = _a.icon;
    return (react_1.default.createElement(kaleidoscope_1.Popover, { className: styles.previewPopover, size: kaleidoscope_1.PopoverSize.Auto, position: kaleidoscope_1.PopoverPosition.Right, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps),
            (0, AutomationUtils_1.toIcon)(icon),
            label)); } },
        react_1.default.createElement(kaleidoscope_1.RainbowBar, null),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical" },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", className: styles.previewImageLabel }, "This is an example of how a typical Qwilr message displays on Slack"),
            react_1.default.createElement(kaleidoscope_1.Card, { className: styles.previewImageCard, elevation: 2 },
                react_1.default.createElement("img", { src: images[image] })))));
};
var getAvailableActions = function (actions, _a) {
    var selectedActions = _a.selectedActions, selectedTrigger = _a.selectedTrigger, includeAction = _a.includeAction;
    return actions.filter(function (action) {
        return ((selectedTrigger ? action.supportedTriggers.includes(selectedTrigger) : true) &&
            (!includesAction(selectedActions, action.id) || (includeAction && action.id === includeAction.id)));
    });
};
var includesAction = function (actions, actionId) { return !!actions.find(function (_a) {
    var id = _a.id;
    return id === actionId;
}); };
var createActionConfig = function (action) {
    return action.form
        ? action.form.reduce(function (result, formField) {
            var _a;
            if (formField.type === "dropdown" && formField.options.length === 1) {
                return __assign(__assign({}, result), (_a = {}, _a[formField.name] = formField.options[0].id, _a));
            }
            else {
                return result;
            }
        }, {})
        : {};
};
